<template>
    <div class="left-content">
        <div class="type-list">
            <span v-for="(val,index) in typeName" :key="index" :class="level === (index+1)?'select':''" @click="level=index+1">{{val}}</span>
        </div>
        <div class="blank30"/>
        <div class="content_con" v-html="richContent"/>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    props:{
        type:{
            type:Number,
            defalut:() => 1,
        }
    },
    computed:
        mapState({
            richContent(state){
                let val;
                const richTextObj = state.richTextObj;
                if(this.type === 1&&this.level === 1){
                    val = richTextObj.chujicfda;
                }else if(this.type === 1&&this.level === 2){
                    val = richTextObj.zhongjicfda;
                }else if(this.type === 2&&this.level === 1){
                    val = richTextObj.chujizhengshuyangben;
                }else{
                    val = richTextObj.zhongjizhengshuyangben;
                }
                return val;
            }
        }),
    async beforeMount() {
        const richTextObj = JSON.parse(JSON.stringify(this.$store.state.richTextObj));
        if(this.type===1){
            this.typeName = ['初级CFDA','中级CFDA'];
            if(!this.richContent){
                const res = await this.$http.get('/api/index/getNavNodes',{nodeName:'招生简章'});
                if(res){
                    res.forEach(item => {
                        if(item.title === '初级CFDA'){
                            richTextObj.chujicfda = item.content;
                        }else if(item.title === '中级CFDA'){
                            richTextObj.zhongjicfda = item.content;
                        }
                    })
                }
            }
        }else{
            this.typeName = ['初级证书样本','中级证书样本'];
            if(!this.richContent){
                const res = await this.$http.get('/api/index/getNavNodes',{nodeName:'证书样本'});
                if(res){
                    res.forEach(item => {
                        if(item.title === '初级证书样本'){
                            richTextObj.chujizhengshuyangben = item.content;
                        }else if(item.title === '中级证书样本'){
                            richTextObj.zhongjizhengshuyangben = item.content;
                        }
                    })
                }
            }
        }
        this.$store.commit('CHANGE_STATE',{richTextObj});
    },
    created() {
        if(this.type===1){
            this.typeName = ['初级CFDA','中级CFDA'];
        }else{
            this.typeName = ['初级证书样本','中级证书样本'];
        }
    },
    data() {
        return {
            typeName:[
            ],
            level:1,
        }
    },
    mounted() {
    },
    methods: {
        slectType(type){
            this.type = type;
        }
    },
}
</script>
<style lang="scss" scoped>
.type-list{
    display: flex;
    flex-direction: row;
    span{
        display: block;
        cursor: pointer;
        height: 49px;
        line-height: 49px;
        font-size: 20px;
        color: #333;
        margin-right: 20px;
        padding: 0 10px;
        font-weight: 400;
    }
    .select{
        font-weight: bold;
        border-bottom: 2px solid #224899;
        color: #224899;
    }
    span:hover{
        color:#224899;
    }
}
</style>
